export const markers = [
  {
    coordinates: [30.382532, 60.025300],
    address: `ELIT МАРКЕТ. ТЦ Флагман, Светлановский пр-т., 48, корпус 4`,
  },
  {
    coordinates: [30.324124, 60.039908],
    address: `ELIT МАРКЕТ. ТЦ Вояж, пр-т. Энгельса, 124, корпус 1`,
  },
  {
    coordinates: [30.510695, 59.892333],
    address: `ELIT МАРКЕТ. ТЦ Мега Дыбенко, Мурманское ш., 1`,
  },
  {
    coordinates: [92.906758, 56.026382],
    address: `ELIT МАРКЕТ. ГМУ, ул. Партизана Железняка д. 8 А`,
  },
  {
    coordinates: [39.735557, 47.228920],
    address: `ELIT МАРКЕТ. пер. Крепостной, д. 104`,
  },
  {
    coordinates: [39.706694, 47.218516],
    address: `Медики. Социалистическая, 52`,
  },
  {
    coordinates: [39.717887, 47.274035],
    address: `Медики. Евдокимова, 39Б`,
  },
  {
    coordinates: [39.203710, 51.678404],
    address: `MEDICAL LINE. ул. Кольцовская, 6`,
  },
];

export const cities = {
  'Санкт-Петербург': {
    zoom: 10,
    center: [30.314997, 59.948784],
    declination: `Санкт-Петербурге`,
  },
  'Красноярск': {
    zoom: 12,
    center: [92.852581, 56.010543],
    declination: `Красноярске`,
  },
  'Ростов-на-Дону': {
    zoom: 11,
    center: [39.720358, 47.222078],
    declination: `Ростове-на-Дону`,
  },
  'Воронеж': {
    zoom: 12,
    center: [39.200296, 51.660781],
    declination: `Воронеже`,
  },
};
